

























































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {CardForm} from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import Api from '@/services';
import UrlMixin from '@/components/query/url-mixin';
import UiSelectLanguage from '@/components/ui/ui-select-language.vue';
import VueRecaptcha from 'vue-recaptcha';
import Recaptcha from '@/views/pages/mixins/recaptcha-mixin.vue';

@Component({
  components: {
    CardForm,
    UiSelectLanguage,
    VueRecaptcha
  }
})
export default class LoginMember extends mixins(UrlMixin, Form, Recaptcha) {
  error: boolean = false;
  error_message: string = '';
  rememberMe: boolean = true;
  edit: boolean = true;
  show_password: boolean = false;
  email: string = '';
  password: string = '';

  get userId() { 
    return this.$route.query.accountId as string; 
  }

  get isAuthenticated() { 
    return !!this.$store.state.isAuthenticated; 
  }

  get dashboardLink() {
    return this.getDashboardLink();
  }

  @Send()
  submit() {
    let viewModel: Bemob.MemberLoginViewModel = {
      userId: this.userId,
      login: this.email,
      password: this.password,
      rememberMe: this.rememberMe, 
      checkCookie: 'no',
      recaptchaResponse: this.recaptchaResponse,
    };

    return Api.memberLogin(viewModel)
      .catch((err) => {
        const {status} = err.response;
        this.showRecaptcha && (this.$refs.recaptcha  as any).reset();
        this.recaptchaResponse = '';

        if(status===401 || status===422){
          this.showRecaptcha = true;
        }

        if(status===400 || status===401 || status===403 || status===429){
          this.error = true;
          this.password = '';
        }

        if(status===429){
          this.error_message = this.t('You’ve reached the maximum login attempts. Try again in 60 minutes.');
        }

        if(status===400 || status===401 || status===403){
          this.error_message = this.t('Email / Password is invalid');
        }
      });
  }

  handleForgotPassword() {
    this.$router.push(
      {
        name: 'forgot-password',
        query: {
          accountId:this.userId
        }
      }
    );
  }
}
